import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { GetAudiencePricingDocument } from '../../../../graphql/query/audiences/GetAudiencePricing.generated.tsx';
import { MatchingOperator } from '../constants.ts';
import type { AudienceForm } from '../types.ts';
import { filterNormalizedEmptyGroups } from '../utils/filterNormalizedEmptyGroups.ts';
import { hasSegmentDataInIncludes } from '../utils/hasSegmentDataInIncludes.ts';

export const useSummaryAlert = () => {
  const observableNormalizedDefinition = useWatch<AudienceForm, 'normalized_definition'>({
    name: 'normalized_definition',
  });
  const observableAccountId = useWatch<AudienceForm, 'account_id'>({
    name: 'account_id',
  });

  const filteredDefinition = filterNormalizedEmptyGroups(observableNormalizedDefinition);

  const { data } = useQuery(GetAudiencePricingDocument, {
    variables: {
      accountId: observableAccountId,
      normalizedDefinition: filteredDefinition,
    },
    skip: !observableAccountId || !hasSegmentDataInIncludes(observableNormalizedDefinition),
  });

  const hasIntersectGroupsWithDifferentAccountId = useMemo(() => {
    return (
      data?.computePricing?.operator === MatchingOperator.INTERSECTION &&
      data?.computePricing?.pricing_by_org.length > 1
    );
  }, [data]);

  return hasIntersectGroupsWithDifferentAccountId;
};
